import { v4 as uuidv4 } from 'uuid';

export const generateUuid = () => {
    return uuidv4();
};

export const idempotencyHeader = () => {
    return { 'Idempotency-Key': generateUuid() };
};
